import { Component, OnInit, inject } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { TranslateModule } from "@ngx-translate/core";

@Component({
  selector: "pa-notfound-page",
  templateUrl: "./not-found-page.component.html",
  styleUrls: ["./error-page.component.scss"],
  imports: [TranslateModule],
})
export class NotFoundPageComponent implements OnInit {
  private activatedRoute = inject(ActivatedRoute);
  private router = inject(Router);

  status?: number;
  message?: string;
  details?: string;

  ngOnInit(): void {
    const navigation = this.router.currentNavigation();
    const data = navigation?.extras?.state || this.activatedRoute.snapshot.data;
    this.status = data?.["status"] as number;
    this.message = (data?.["message"] as string) ?? ``;
    if (typeof this.message !== "string") {
      this.message = JSON.stringify(this.message);
    }

    this.details = (data?.["details"] as string) ?? `Page '${this.activatedRoute.snapshot.url.toString()}'`;
  }
}
